import { useHistory} from "react-router-dom";
  
export default function Footer() {
    const history = useHistory();
    const redirectToURL = (page: string) => {
    const url = "/" + page;
    history.push(url)
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="bg-gray-800 w-full mx-auto py-4 px-4 overflow-hidden sm:px-6 lg:px-8">
      <div className="mt-8">
        <p className="text-center text-base leading-6 text-gray-100">
            © {currentYear} &#9971; &#127948;1PuttHealth LLC - All rights reserved.
        </p>
      </div>
    </div>
  );
}
